<template>
    <div class="d-inline-flex flex-row cursor-pointer" @click="sort">
        <div>
            <slot/>
        </div>
        <div class="ml-2 d-flex flex-column chevrons" style="margin-top: 3px;">
            <div class="mt-n1 mb-n1">
                <i class="fas fa-angle-up"
                   :class="{
                    'text-muted opacity-25': !sortActive || sortDirection !== 'asc',
                    'text-primary': sortActive && sortDirection === 'asc'
                }"/>
            </div>
            <div class="mb-n2" style="margin-top: -1px;">
                <i class="fas fa-angle-down"
                   :class="{
                    'text-muted opacity-25': !sortActive || sortDirection !== 'desc',
                    'text-primary': sortActive && sortDirection === 'desc'
                    }"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: String,
        value: [Object, Array],
    },

    data() {
        return {
            sortDirection: 'none',
        };
    },

    beforeMount() {
        if (this.sortActive) {
            this.sortDirection = this.sortingField?.type || 'none';
        }
    },

    methods: {
        sort() {
            switch (this.sortDirection) {
                case 'none':
                    this.sortDirection = 'asc';
                    break;
                case 'asc':
                    this.sortDirection = 'desc';
                    break;
                case 'desc':
                    this.sortDirection = 'none';
                    break;
            }

            this.$emit('input', this.sortDirection === 'none' ? {} : {field: this.field, type: this.sortDirection});
        },
    },

    computed: {
        sortingField() {
            if ((!this.value || !this.value.field) && this.sortDirection !== 'none') {
                return this.field;
            }
            return this.value?.field || null;
        },

        sortActive() {
            return this.sortingField === this.field;
        },
    },

    watch: {
        value: {
            deep: true,
            handler(newVal) {
                if (newVal.field === this.field) {
                    this.sortDirection = newVal.type || 'none';
                } else {
                    this.sortDirection = 'none';
                }
            },
        },
    },
};
</script>

<style>
.chevrons {
    line-height: .2em;
}
</style>
